export const DELETE_PRICING_OFFER = gql`
    mutation deletePricingOffer($id: Int!) {
        deletePricingOffer(id: $id)
    }
`;
